export const SET_PREVIEW_COLOR = "SET_PREVIEW_COLOR";
export const SWITCH_TOGGLE = "SWITCH_TOGGLE";
export const SET_FONT_FAMILY = "SET_FONT_FAMILY";